<template>
  <div class="domains">
      <Card v-if="Domains" class="">
            <template #title>
              <div class="p-grid">
                <div class="p-col-4 p-md-1 p-pt-3">
                  Domains
                </div>
                <div class="p-col-8 p-md-4">
                  <Button icon="pi pi-plus" class="p-button-rounded p-button-primary" @click="openNewDomainModal" />
                </div>
                <div v-if="user && user.is_superadmin" class="p-col-12 p-md-7 p-pt-4">
                  <Checkbox id="ownDomains" :binary="true" v-model="params.filter_self" @change="changeFilters"></Checkbox>
                  <label for="ownDomains" style="font-size: 13px; font-weight: normal;" class="p-pl-2">Show only my domains</label>
                </div>
              </div>
            </template>
            <template #content>
                <DataTable :value="Domains.domains" class="p-datatable-sm" responsiveLayout="scroll" @row-click="selectDomain($event.data.id)" rowHover stripedRows selectionMode="single" :rows="20" :paginator="true">
                    <template #empty>
                      <div style="text-align: center;">No domains found</div>
                    </template>
                    <Column field="name" header="Name"></Column>
                    <Column v-if="user && user.is_superadmin && !params.filter_self" field="owner.login" header="Owner"></Column>
                    <Column header="Services">
                      <template #body="{data}">
                        <span v-for="value, service in getAttributes(data.attributes, 'services')" class="p-mr-2">
                          <i v-if="value.enabled && service == 'dns'" class="pi pi-database" v-tooltip.bottom="'DNS'" style="color:var(--green-400)"></i>
                          <i v-if="value.enabled && service == 'mail'" class="pi pi-envelope" v-tooltip.bottom="'Mail'" style="color:var(--blue-400)"></i>
                        </span>
                      </template>
                    </Column>
                    <Column header="Active" headerStyle="width: 100px; text-align: right">
                      <template #body="slotProps">
                        <i v-if="slotProps.data.is_enabled" style="color:var(--green-400)" class="pi pi-check-circle"></i>
                        <i v-else style="color:var(--orange-400)" class="pi pi-minus-circle"></i>
                      </template>
                  </Column>
                </DataTable>
            </template>
      </Card>
  </div>
  <Toast />
  <Dialog header="New Domain" v-model:visible="displayNewDomainModal" :modal="true">
      <div class="new-account p-pt-4">
          <form class="p-fluid" autocomplete="off" v-on:submit.prevent>
              <div class="p-field">
                  <div class="p-float-label">
                      <InputText id="login" v-model="domain.name" autocomplete="off" v-on:keyup.enter="createDomain" autofocus />
                      <label for="login">Name *</label>
                      <small class="p-error" v-if="errors.name">{{ errors.name }}</small>
                  </div>
              </div>
              <div class="p-field-checkbox">
                  <Checkbox id="active" :binary="true" v-model="domain.is_enabled"></Checkbox>
                  <label for="active">Active</label>
              </div>
              <h5>Services</h5>
              <div v-for="service of services" :key="service.key" class="p-field-checkbox">
                  <Checkbox :id="service.key" name="service" :value="service.key" v-model="domain.services"/>
                  <label :for="service.key">{{service.name}}</label>
              </div>
              <div class="p-mb-3" v-if="errors && errors[0] && errors[0].fatal">
                <small class="p-error p-pb-4" v-if="errors[0].fatal">{{ errors[0].fatal }}</small>
              </div>
              
          </form>
      </div>
      <template #footer>
        <Button label="Create" icon="pi pi-check-square" class="w-full" :loading="loading" @click="createDomain"></Button>
      </template>
  </Dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { get, set } from 'idb-keyval';
import { convertErrors } from "../helpers/errors.js"
import { getAttributes } from "../helpers/attributes.js"

export default {
  name: 'Domains',
  components: {

  },
  data () {
    return {
      displayNewDomainModal: false,
      domain: {id: '', name: '', services: ['dns', 'mail'], is_enabled: true},
      errors: {},
      loading: false,
      selectedServices: [],
      services: [
        {"key": "dns", "name": "DNS"},
        {"key": "mail", "name": "Mail"},
      ],
      params: { filter_self: true },
      filters: {
        'global': {value: null},
      }
    }
  },
  created: function () {
    get('domains_filters')
      .then((val) => {
        if (val) {
          this.params = JSON.parse(val)
        }
      })
      .finally(() => this.GetDomains(this.params))
  },
  computed: {
    ...mapGetters({ Domains: 'StateDomains' }),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    ...mapActions(['CreateDomain', 'GetDomains']),
    async submit () {
      await this.CreateDomain(this.form)
    },
    async selectDomain(id) {
      this.$router.push('/domains/' + id)
    },
    getAttributes: getAttributes,
    getServices(attr) {
      if (attr) { 
        const result = attr.find( x => x.key === "services");
        if (result) {
          return result["value"]
        }
      }
    },
    openNewDomainModal() {
      this.domain = {id: '', name: '', services: ['dns', 'mail'], is_enabled: true}
      this.displayNewDomainModal = true
    },
    async createDomain () {
      this.loading = true
      this.errors = {}
      
      //this.account.domain_id = this.$route.params.domain_id

      this.CreateDomain(this.domain)
        .then(response => {
          this.displayNewDomainModal = false
          this.domain = {id: '', name: '', services: ['dns', 'mail'], is_enabled: true}
          this.$toast.add({severity:'success', summary: 'Domain created', detail:response.data.name, life: 3000});
          this.GetDomains(this.params)
        })
        .catch(error => {
          this.errors = convertErrors(error.response.data)
        })
        .finally(() => this.loading = false)
    },
    changeFilters() {
      set('domains_filters', JSON.stringify(this.params))

      this.GetDomains(this.params)
    }
  }
}
</script>

<style scoped>

</style>
